import React from 'react';

export function PromotionSectionCard({ children }: { children: React.ReactNode }) {
  return (
    <div className="bg-white mb-4 rounded-lg shadow-md p-4 min-w-[550px] relative border">
      {children}
    </div>
  );
}
